import { render, staticRenderFns } from "./mainSafetyHealthyTarget.vue?vue&type=template&id=2a3fc8c5"
import script from "./mainSafetyHealthyTarget.vue?vue&type=script&lang=js"
export * from "./mainSafetyHealthyTarget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a3fc8c5')) {
      api.createRecord('2a3fc8c5', component.options)
    } else {
      api.reload('2a3fc8c5', component.options)
    }
    module.hot.accept("./mainSafetyHealthyTarget.vue?vue&type=template&id=2a3fc8c5", function () {
      api.rerender('2a3fc8c5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sai/main/mainSafetyHealthyTarget.vue"
export default component.exports